import apiUrl from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import router from 'vue-router';


export default {
	name: 'osticket',
	components: {
		VueElementLoading
	},
	props: [],
	data() {
		return {
			userName: "",
			userEmail: "",
			userId: "",
			isLoading: false,
			ticketlogin: false,
		}
	},
	computed: {

	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.userEmail = userdetail.email;
		this.userName = userdetail.fullname;
		this.userId = userdetail.userid;
		this.checkTicketlogin(0)
	},
	methods: {
		checkTicketlogin(check) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var input = ({
				check: check,
				userid: this.userId,
				username: this.userName,
				useremail: this.userEmail
			})
			this.isLoading = true
			axios({
					method: "post",
					url: apiUrl.api_url + "ticketLoginUpdate",
					'data': input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					},
				})
				.then((response) => {
					if (check == 0 && response.data.ticketlogin == 1) {
						this.ticketlogin = true
						this.$alertify.success("User is Registered")
						this.$router.push('/ticketlisting');
					} else if (check == 1 && response.data.status) {
						this.ticketlogin = true
						this.$alertify.success("User Registered Successfully")
						this.$router.push('/ticketlisting');
					}
					this.isLoading = false
				}).catch((error) => {
					this.isLoading = false
					console.log(error);
				});
		},
		onSubmit: function(event) {
			this.$validator.validateAll().then((result) => {
				if (result) {
					console.log('form is valid')
					this.checkTicketlogin(1)
					event.target.reset();
				} else {
					return false;
				}
			}).catch(() => {
				console.log('errors exist', this.errors)
			})
		},
	}
}


// WEBPACK FOOTER //
// ./src/views/components/osticket/osticket.component.js